<template>
  <div class="divWrap">
  </div>
</template>

<script>
import $ from 'jquery'

import { get } from '@/api/common'
export default {
  name: 'sso',
  data () {
    return {
      loginForm: {
        code: '',
        sPassword: '',
        sLoginType: 'WEB'
      }
    }
  },
  created () {
    // console.log('sso login params：' + JSON.stringify(this.$route.params))
    // console.log('sso login query：' + JSON.stringify(this.$route.query))
    // 通过url直接传参到此页面时，截取url中的username
    if (this.$route.params && this.$route.params.code) {
      this.loginForm.code = this.$route.params.code
    } else if (this.$route.query && this.$route.query.code) {
      this.loginForm.code = this.$route.query.code
    } else {
      this.$notify({
        title: '提示',
        message: '参数错误',
        type: 'warning'
      })
      return
    }
    this.doLogin()
  },
  mounted: function () {
  },
  methods: {
    doLogin: function () {
      // 必须输入账号
      if (this.loginForm.code === '') {
        this.$notify({
          title: '提示',
          message: '参数错误',
          type: 'warning'
        })
        $('#username').focus()
        return
      }

      let url = '/uas/user/getCodeToAuth'
      let params = {
        code: this.loginForm.code
      }
      get(url, params).then(response => {
        // console.log('sso login：', response)
        if (response.data.code !== 0) {
          this.showFailureMessage('登录失败')
        } else {
          localStorage.setItem('userId', response.data.data.userId)
          localStorage.setItem('userType', response.data.data.userType)
          localStorage.setItem('userName', response.data.data.userName)
          localStorage.setItem('userCount', response.data.data.userCount)
          sessionStorage.setItem('token', response.data.data.token)

          if (response.data.data.userType === 'adminUser') {
            this.$router.push({
              name: 'questionRecord'
            })
          } else {
            this.$router.push({
              name: 'PersonSend'
            })
          }
        }
        // localStorage.setItem('sUserId', sUserId)
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '登录失败',
          type: 'warning'
        })
      })
    },
    showSuccessMessage: function (keyWord) {
      this.$notify({
        title: '提示',
        message: keyWord,
        type: 'success'
      })
    },
    showFailureMessage: function (keyWord) {
      this.$notify({
        title: '提示',
        message: keyWord,
        type: 'warning'
      })
    },
    showExceptionMessage: function () {
      this.$notify({
        title: '提示',
        message: '系统异常：请联系管理员！',
        type: 'error'
      })
    }
  }
}
</script>

<style scoped>
  .divWrap{
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: 100% 100% !important;
    background: linear-gradient(#7db4ff, #2c77ea);
    /*background-img: url();*/
  }
</style>



// WEBPACK FOOTER //
// src/views/common/sso.vue